import React from 'react';
import { CheckCircle, Users, Award } from 'lucide-react';

const SocialProofSection = () => {
  const stats = [
    {
      number: "40+",
      label: "Hours Saved",
      description: "Per week on manual reporting"
    },
    {
      number: "80%",
      label: "Cost Reduction",
      description: "In admin overhead expenses"
    },
    {
      number: "2x",
      label: "Faster Decisions",
      description: "With real-time insights"
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Trusted by 10+ CPA Firms
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Join growing firms that have transformed their practice management with real results
          </p>
        </div>
        
        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center p-6 sm:p-8 bg-gray-50 rounded-xl border border-gray-100">
              <div className="text-3xl sm:text-4xl font-bold text-orange-500 mb-2">
                {stat.number}
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">
                {stat.label}
              </h3>
              <p className="text-base sm:text-lg text-gray-600">
                {stat.description}
              </p>
            </div>
          ))}
        </div>
        
        {/* Trust Indicators */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-50 rounded-xl p-6 sm:p-8 border border-gray-100">
            <div className="flex flex-col sm:flex-row items-center justify-center mb-6">
              <Users className="w-6 h-6 sm:w-8 sm:h-8 text-blue-600 mb-2 sm:mb-0 sm:mr-3" />
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-900">Proven Results</h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div className="flex items-start space-x-3">
                <CheckCircle className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-gray-900 text-base sm:text-lg">Quick Setup</p>
                  <p className="text-sm sm:text-base text-gray-600">1-2 week implementation</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <CheckCircle className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-gray-900 text-base sm:text-lg">Secure Integration</p>
                  <p className="text-sm sm:text-base text-gray-600">Data stays within your infrastructure</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <CheckCircle className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-gray-900 text-base sm:text-lg">No Disruption</p>
                  <p className="text-sm sm:text-base text-gray-600">Works with existing Practice CS</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <CheckCircle className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-gray-900 text-base sm:text-lg">Dedicated Support</p>
                  <p className="text-sm sm:text-base text-gray-600">Personal onboarding and training</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;